/* External */
import * as React from 'react';

/* Utils */
import CursorStateContext from './CursorStateContext';
import {
  addCursorVisibilitySubscriber,
  getCursorVisibility,
  removeCursorVisibilitySubscriber,
} from './utils';

const { memo, useEffect, useState } = React;

type Props = {
  children?: React.ReactNode
};

function CursorStateProvider(
  {
    children,
  }: Props,
): React.ReactElement {
  const [
    isCursorVisible, setIsCursorVisible,
  ] = useState<boolean>(() => getCursorVisibility());

  useEffect(() => {
    function onCursorVisibilityChange(newCursorVisibility: boolean) {
      setIsCursorVisible(newCursorVisibility);
    }

    setIsCursorVisible(getCursorVisibility());
    addCursorVisibilitySubscriber(onCursorVisibilityChange);

    return () => {
      removeCursorVisibilitySubscriber(onCursorVisibilityChange);
    };
  }, []);

  return (
    <CursorStateContext.Provider value={isCursorVisible}>
      {children}
    </CursorStateContext.Provider>
  );
}

export default memo<Props>(CursorStateProvider);
